import { useTranslation } from "react-i18next";

import { SimpleGrid, Text } from "@mantine/core";

import { useFormatters } from "@prostocheck/i18n";
import { Card } from "@prostocheck/ui";

import { IPeriodTotalsProps } from "./period-totals.models";

/** The four numbers the period is usually opened for. */
export const PeriodTotals = ({ report }: IPeriodTotalsProps) => {
  const { t } = useTranslation();
  const { formatNumber, formatPrice } = useFormatters();

  return (
    <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing="md">
      <Card>
        <Text size="sm" c="dimmed">
          {t("period.sales")}
        </Text>
        <Text size="xl" fw={600} mt="xs">
          {formatPrice(report.salesTotal)}
        </Text>
      </Card>
      <Card>
        <Text size="sm" c="dimmed">
          {t("period.returns")}
        </Text>
        <Text size="xl" fw={600} mt="xs">
          {formatPrice(report.returnsTotal)}
        </Text>
      </Card>
      <Card>
        <Text size="sm" c="dimmed">
          {t("period.net")}
        </Text>
        <Text size="xl" fw={600} mt="xs" c="brand.7">
          {formatPrice(report.netTotal)}
        </Text>
      </Card>
      <Card>
        <Text size="sm" c="dimmed">
          {t("period.shiftsAndReceipts")}
        </Text>
        <Text size="xl" fw={600} mt="xs">
          {formatNumber(report.shiftsCount)} /{" "}
          {formatNumber(report.receiptsCount)}
        </Text>
      </Card>
    </SimpleGrid>
  );
};
